import React from 'react'
import WienLeben from '../AuslandPage/WienLeben'
import EuNature from '../AuslandPage/EuNature'
import DeLeben from '../AuslandPage/DeLeben'
import DeNature from '../AuslandPage/DeNature'

export default function AuslandPage() {
      return (
            <div>
                  <DeLeben />
                  <DeNature />
                  <WienLeben />
                  <EuNature />
            </div>
      )
}
